import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'

const DEVICE_ID_KEY = 'deviceId'

export const getCookie = (cookieKey: string): string | null => {
    const keyIdentifier = `${cookieKey}=(.*)`
    const keyRegex = new RegExp(keyIdentifier)
    const cookieList = document.cookie.split(';').map((cookieItem) => cookieItem.trim())

    let cookieValue = null
    cookieList.forEach((cookieItem) => {
        if (cookieItem.match(keyRegex) && cookieItem.match(keyRegex)[1]) {
            cookieValue = cookieItem.match(keyRegex)[1]
        }
    })

    return cookieValue
}

export const setCookie = (cookieKey: string, cookieValue: string, exDays: number): void => {
    const date = new Date()
    date.setTime(date.getTime() + (exDays * 24 * 60 * 60 * 1000))
    const expires = `expires=${date.toUTCString()}`
    document.cookie = cookieKey + '=' + cookieValue + '; ' + expires
}

export const loadDeviceId = (): string => {
    let deviceId: string | null = null

    if (typeof (Storage) !== 'undefined') {
        deviceId = window.localStorage[DEVICE_ID_KEY] || null
    } else {
        console.log('ATBase: HTML5 local storage is not supported, falling back to cookie storage while loading device ID.')
        deviceId = getCookie(DEVICE_ID_KEY)
        if (deviceId) {
            // Reset cookie expiration if cookie present
            setCookie(DEVICE_ID_KEY, deviceId, 365)
        }
    }

    // Hardcoded fallback device ID to avoid the prompt on SMP load.
    // BYOD uses DeviceInfoService.getDeviceId() from native module instead:
    // https://code.amazon.com/packages/JWOStoreManagementApp/blobs/227db82422431b5e12718c16adc2767678cc433f/--/src/deviceinfo/DeviceInfoService.ts#L36
    // TODO: Remove this fallback logic.
    return deviceId || 'AT_Roving_Device'
}

export const setDevice = (deviceId: string) => {
    if (typeof (Storage) !== 'undefined') {
        window.localStorage[DEVICE_ID_KEY] = deviceId
    } else {
        console.log(`HTML5 local storage is not supported, falling back to cookie storage while setting device ID: ${deviceId}.`)
        setCookie(DEVICE_ID_KEY, deviceId, 365)
    }
}

export const promptForId = (promiseResolver?: (value: unknown) => void): void => {
    // In React Native WebView, window.prompt() returns '' (empty string) which
    // causes the while-loop to block the JS thread forever.  Use the localStorage
    // value injected by the RN app, or fall back to 'unknown-device'.
    if ((window as any).ReactNativeWebView) {
        const resolvedId = loadDeviceId() || 'unknown-device'
        setDevice(resolvedId)
        if (promiseResolver) {
            promiseResolver(resolvedId)
        }
        return
    }

    let deviceId: string = null

    while (deviceId == null || deviceId.length <= 0) {
        deviceId = window.prompt('Please enter an ID for this device.', 'AT_Roving_Device')
        if (deviceId != null) {
            deviceId = deviceId.trim()
        }
    }

    setDevice(deviceId)

    if (promiseResolver) {
        promiseResolver(deviceId)
    }
}

export const getDeviceId = (): Promise<string> => {
    const deferred = generateDeferredPromise<string>()
    const deviceId = loadDeviceId()
    console.log('ATBase: Loading deviceId: ', deviceId)
    deferred.resolve(deviceId)
    return deferred.promise
}
